import { useState } from "react";
import style from "./AgentRegister.module.css";
import AgentForm from "./AgentForm";
import { Link } from "react-router-dom";

function AgentRegister() {
  const [personType, setPersonType] = useState(0);

  return (
    <div className="container">
      <h6 className="text-end mb-4">
        <span>اگر قبلا ثبت نام کردید یا فرم درخواست را پر کردید ، ابتدا </span>
        <Link to="/login">وارد</Link>
        <span> شوید</span>
      </h6>
      <div className={"w-100 " + style.section} dir="rtl">
        <div className={style.header}>
          <button
            className={
              "nav-link" + (personType === 0 ? " " + style.active : "")
            }
            onClick={() => setPersonType(0)}
          >
            حقیقی
          </button>
          <button
            className={
              "nav-link" + (personType === 1 ? " " + style.active : "")
            }
            onClick={() => setPersonType(1)}
          >
            حقوقی
          </button>
        </div>

        <AgentForm personType={personType} />
      </div>
    </div>
  );
}

export default AgentRegister;
